export default __webpack_public_path__ + "static/Image 45-916fa1646521860072d57706f923f917.png";